<!--
 * @Author: your name
 * @Date: 2020-08-12 23:02:59
 * @LastEditTime: 2022-11-07 14:05:49
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/NavBar/index.vue
-->
<style scoped lang="sass">

.nav_bar
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  height: 58px
  line-height: 58px
  background: var(--menu-header-background-colour)
  color: var(--menu-header-colour)
  z-index: 2

  .right
    display: flex
    justify-content: center
    align-items: center
    height: 60px

  .left
    display: flex
    justify-content: center
    align-items: center
    height: 60px
    width: 60px
    margin-left: -13PX

  .title
    text-align: center
    flex: 1
    overflow: hidden
    font-size: 17px

.arrow_left
  height: 45px
  width: 45px
</style>

<template lang="pug">
.nav_bar
  .left.p(v-if="showMenu")
    img.arrow_left(
      v-if="enableShowArrow || isSubGroupMode"
      src="@/assets/navPic/arrow_left.png"
      @click="prev"
    )
    manage-center(
      v-else
      :showManageCenter="showManageCenter"
      v-on="$listeners"
    )
  .title.f3.van-ellipsis {{ translatedTitle }}
  .right(v-if="showMenu")
    locale-selector(
      v-if="hasLocaleOptions"
    )
    manage-center(
      v-if="!isSubGroupMode && !hasLocaleOptions"
      :showManageCenter="showManageCenter"
      v-on="$listeners"
    )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import ManageCenter from 'components/ManageCenter'
import LocaleSelector from '@/components/LocaleSelector'
import { t } from '@/utils/language'
import { enableShowArrowList, specialEnableShowArrowPageList } from 'modules/navBar'
import { mapGetters, mapState } from 'vuex'

// Title translation mapping / 标题翻译映射
const TITLE_TRANSLATIONS = {
  'My cart': 'my_cart',
  'Contact details': 'contact_details',
  'Select a payment method': 'select_payment_method',
  'Card details': 'card_details',
  'Order history': 'order_history',
  'Tap & Pay': 'tap_and_pay',
  'Payment received': 'payment_received',
  'Order received': 'order_received_title',
}

@Component({
  components: {
    ManageCenter,
    LocaleSelector,
  },

  created() {
    const self = this
    window.addEventListener('message', function(e) {
      if (e.data.name === 'isIframe') {
        self.disabledButton = true
      }
    })
  },

  computed: {
    ...mapState(['isFromMenuToStartTab']),
    ...mapGetters('language', ['hasMultipleLanguages']),
    ...mapGetters('currencySettings', ['hasMultipleCurrencies']),

    // Whether locale-selector should show (has multiple languages or currencies)
    // locale-selector 是否显示（有多语言或多货币）
    hasLocaleOptions() {
      return this.hasMultipleLanguages || this.hasMultipleCurrencies
    },

    /**
     * Show Left Menu
     * @returns {Boolean} Whether to display the left menu
     */
    /**
     * 控制显示左侧的菜单
     * @returns {Boolean} 是否显示左侧菜单
     */
    showMenu() {
      let isPass = true
      // url 中带有 '/r/v/'，说明是只读模式
      const isReadOnly = this.$route.path.includes('/r/v/')
      if (isReadOnly) {
        // Read only mode, and the current route is in the urlNameList list, and the menu is not displayed
        // 只读模式，并且当前路由在 urlNameList 列表中，不显示菜单
        const urlNameList = ['venue-home-pick', 'venue-home-no-table', 'venue-home-table']
        const index = urlNameList.findIndex(item => item === this.$route.name)
        isPass = index < 0
      }
      return isPass
    },

    venueId() {
      return this.$store.state.venueId
    },

    routerInfo() {
      return this.$store.state.venueHome.routerInfo
    },

    isFromOrderHistoryToOrderDetail() {
      return this.$store.state.isFromOrderHistoryToOrderDetail
    },

    // Whether to display the return to previous page button
    // 是否显示 '返回上一页面' 的按钮
    enableShowArrow() {
      return (this.showArrow && this.isEnableShowPage) || this.specialEnableShowArrowPage
    },

    specialEnableShowArrowPage() {
      const currentPageName = this.$route.name
      return specialEnableShowArrowPageList.includes(currentPageName) && !this.isFromMenuToStartTab
    },

    isSubGroupMode() {
      return !!this.$store.state.venueHome.subGroupId
    },

    isEnableShowPage() {
      const currentPageName = this.$route.name
      return enableShowArrowList.includes(currentPageName)
    },
    fromOrderHistory() {
      return this.$route.query?.orderHistory === 'true'
    }
  },

  model: {
    prop: 'showManageCenter',
    event: 'changeManageCenterShow'
  },

  props: {
    barTitle: [String, Number],
    showArrow: Boolean,
    showManageCenter: {
      type: Boolean
    }
  },

  watch: {
    barTitle: {
      immediate: true,
      handler(val) {
        if (val) document.title = val
      },
    },
  },
})
class NavBar extends Vue {
  disabledButton = false
  color = '#fff'

  /**
   * Get translated title / 获取翻译后的标题
   */
  get translatedTitle() {
    const key = TITLE_TRANSLATIONS[this.barTitle]
    if (key) {
      return t(key, this.barTitle)
    }
    return this.barTitle
  }

  jumpToIndex() {
    if (this.isSubGroupMode) {
      // sub-group 模式下仅使用 routerInfo.number（来自路由 params 的真实桌号），不使用 query 中的 tableNumber
      const tableNumber = this.routerInfo.number
      if (tableNumber) {
        this.$router.push(`/vgs/${this.$store.state.venueHome.subGroupId}/t/${tableNumber}`)
      } else {
        this.$router.push(`/vgs/${this.$store.state.venueHome.subGroupId}`)
      }
    } else {
      const tableNumber = this.routerInfo.number || this.$route.query.tableNumber
      if (tableNumber) {
        this.$router.push(`/v/${this.venueId}/home/t/${tableNumber}`)
      } else {
        this.$router.push(`/v/${this.venueId}/home/p`)
      }
    }
  }

  prev() {
    if (this.disabledButton) return

    const jumpToIndexRouterNameList = [
      'order-history',
      'my-order',
      'pay',
      'venue-sub-group-order-history',
      'venue-sub-group-my-order',
      'venue-sub-group-pay',
    ]
    const currentRouterName = this.$route.name

    if (jumpToIndexRouterNameList.includes(currentRouterName)) {
      this.isFromOrderHistoryToOrderDetail || this.fromOrderHistory ? this.$emit('prev') : this.jumpToIndex()
    } else if (this.isSubGroupMode && this.$route.path.includes('/home/p')) {
      this.$router.push(`/vgs/${this.$store.state.venueHome.subGroupId}`)
    } else {
      this.$emit('prev')
    }
  }
}

export default NavBar
</script>
